import { values, toArray } from "lodash";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";
import { undefinedAsTrue } from "Utils/formDataHelpers";

import { fetchPricing } from "Common/PlanLoader/api";

// initialize dependent enrollment with employee enrollment since we want
// to default is_enrolling to true, but deps can't enroll if ee isn't enrolling
const getEmployeeEnrollment = (employee) => ({
  is_enrolling: undefinedAsTrue(employee.is_enrolling),
  is_enrolling_dental: undefinedAsTrue(employee.is_enrolling_dental),
  is_enrolling_vision: undefinedAsTrue(employee.is_enrolling_vision),
});

const getDependentEnrollment = (employee, dependent) => {
  const employeeEnrollment = getEmployeeEnrollment(employee);
  return {
    is_enrolling: employeeEnrollment.is_enrolling ? dependent.is_enrolling : false,
    is_enrolling_dental: employeeEnrollment.is_enrolling_dental ? dependent.is_enrolling_dental : false,
    is_enrolling_vision: employeeEnrollment.is_enrolling_vision ? dependent.is_enrolling_vision : false,
  };
};

const formatDependents = (employee) => {
  const defaultEnrollment = getEmployeeEnrollment(employee);
  const spouse = employee?.spouse_age
    ? {
        name: "Spouse",
        age: employee.spouse_age,
        ...(employee.spouse_enrollment ? employee.spouse_enrollment : defaultEnrollment),
      }
    : undefined;
  const children = employee?.children?.map((age, index) => ({
    name: `Child ${index + 1}`,
    age,
    ...(employee.children_enrollment ? employee.children_enrollment[index] : defaultEnrollment),
  }));

  return spouse ? [spouse, ...children] : [...children];
};

export const formatEmployeeInfo = (employee) => ({
  ...employee,
  dependents: values(formatDependents(employee)),
});

const recievePricing = (plans, pricing) => {
  const newPlans = plans.map((plan) => {
    let newPlan = plan;
    if (pricing.averageMonthlyPremiums[plan.id]) {
      newPlan = {
        ...plan,
        prices_loading: false,
        average_monthly_premium_per_person: parseInt(pricing.averageMonthlyPremiums[plan.id][3].toFixed(2), 10),

        average_monthly_premium: parseInt(pricing.averageMonthlyPremiums[plan.id][0].toFixed(2), 10),

        employee_costs: toArray(pricing.employeeCosts[plan.id]),
        total_cost: parseInt(pricing.totalCosts[plan.id].toFixed(2), 10),
      };
    }
    return newPlan;
  });
  return newPlans;
};

export const requestPricing = (employees, plans, dentalPlan, visionPlan, companyIDToken, setPlans, setDentalPlans, setVisionPlans) => {
  const planIds = plans.map((plan) => plan.id);
  fetchPricing(employees, planIds, companyIDToken)
    .then((response) => response.json())
    .then((data) => {
      const newPlans = recievePricing(plans, {
        planIDs: data.plan_ids,
        averageMonthlyPremiums: data.average_monthly_premiums,
        employeeCosts: data.employee_costs,
        totalCosts: data.total_costs,
      });

      setPlans(newPlans);
    });

  if (dentalPlan != undefined) {
    fetchWithCSRFToken(`/small-group/select-plan/ajax-selected-dental-plan?company_id_token=${companyIDToken}`, {
      method: "POST",
      body: JSON.stringify({ employee_profile: JSON.stringify(employees) }),
    })
      .then((response) => response.json())
      .then((data) => {
        setDentalPlans(data.results[0]);
      });
  }
  if (visionPlan != undefined) {
    fetchWithCSRFToken(`/small-group/select-plan/ajax-selected-vision-plan?company_id_token=${companyIDToken}`, {
      method: "POST",
      body: JSON.stringify({ employee_profile: JSON.stringify(employees) }),
    })
      .then((response) => response.json())
      .then((data) => {
        setVisionPlans(data.results[0]);
      });
  }
};

export const formatUpdatedEmployeeProfile = (employeeProfile) => {
  const updatedEmployeeProfile = [];

  employeeProfile.map((employee) => {
    const updatedEmployee = {
      age: employee.age,
      name: employee.name,
      children: [],
      role: employee.role,
      selected_medical_plan: employee.selected_medical_plan,
      ...getEmployeeEnrollment(employee),
      full_time: employee.full_time,
    };

    const spouseIndex = employee.dependents.findIndex((dependent) => dependent.name === "Spouse");

    if (spouseIndex !== -1) {
      updatedEmployee.spouse_age = employee.dependents[spouseIndex]?.age;
      updatedEmployee.spouse_enrollment = getDependentEnrollment(employee, employee.dependents[spouseIndex]);

      const children = employee.dependents.filter((dependent) => dependent.name !== "Spouse");

      updatedEmployee.children_enrollment = [];
      children.forEach((child) => {
        updatedEmployee.children.push(child?.age);
        updatedEmployee.children_enrollment.push(getDependentEnrollment(employee, child));
      });
    } else if (employee.dependents.length > 0) {
      updatedEmployee.children_enrollment = [];
      employee.dependents.forEach((child) => {
        updatedEmployee.children.push(child?.age);
        updatedEmployee.children_enrollment.push(getDependentEnrollment(employee, child));
      });
    }
    updatedEmployee.dependents = employee.dependents;
    updatedEmployeeProfile.push(updatedEmployee);
  });
  return updatedEmployeeProfile;
};
